import React, { useCallback, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { Page } from '@client/style/Shared';
import Menu from '@client/modules/Menu/Menu';
import { Breakpoints, presetColors } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import ListWithImage from '@client/modules/ListModules/ListWithImage';
import SingleImageEntity from '@client/modules/ListModules/SingleImageEntity';
import Spilleplan from '@client/modules/Spilleplan/Spilleplan';
import { gsap } from 'gsap';
import Functions from '@client/style/Functions';

const DayColors = [
	presetColors.sunkiss,
	presetColors.nude,
	presetColors.seablue,
	presetColors.solgult1,
	presetColors.kissMeRed,
	presetColors.himmelblue,
	presetColors.weirdgreen,
];

const StyledPage = styled(Page)`
	background-color: ${DayColors[0]};
	color: ${presetColors.blackish};
`;

const StyledListWithImage = styled(ListWithImage)`
	padding: 50px var(--gridMargin);
`;

const ListTitle = styled.h2`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p4')}

	margin-top: 40px;
	margin-bottom: 0;

	color: ${presetColors.blackish};

	${Functions.breakpoint(Breakpoints.laptop)} {
		margin-top: 80px;
		${TextStyle.size('p2')}
	}
`;

export default function SpilleplanPage(props: {
	content?: {
		_prefix: string;
		slug: string;
		_artists: any[];
		filter: [{ name: string; id: string }];
		additionalEvents: any[];
	};
}) {
	const pageRef = useRef<HTMLDivElement>(null);
	const onDayChange = useCallback(
		(index: number) => {
			gsap.to(pageRef.current, {
				backgroundColor: DayColors[index % DayColors.length],
				duration: 0.5,
			});
		},
		[pageRef.current]
	);

	const hasAdditionalEvents = useMemo(() => {
		return props.content && props.content?.additionalEvents.length > 0;
	}, [props.content]);

	return (
		<StyledPage ref={pageRef}>
			<Menu specificColor={presetColors.blackish} />
			<Spilleplan artists={props.content?._artists ?? []} onDayChange={onDayChange} filter={props.content?.filter} />
			{hasAdditionalEvents && (
				<>
					<ListTitle>Det sker hele tiden</ListTitle>
					<StyledListWithImage>
						{props.content?.additionalEvents.map((artist, i) => (
							<SingleImageEntity item={artist} index={i} key={'SingleImageEntity_' + i}></SingleImageEntity>
						))}
					</StyledListWithImage>
				</>
			)}
		</StyledPage>
	);
}
